<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="save()" type="submit" [disabled]="form.invalid">Save</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()" type="submit">Cancel</button>
</div>